import React from 'react';
import { useMediaQuery } from '../../hooks/utils/useMediaQuery';
import { AccountSummary } from './components/AccountSummary';
import { SettingsPanel } from './components/SettingsPanel';
import { SettingsCards } from './components/SettingsCards';
import { ActivitySection } from './components/ActivitySection';
import { SupportSection } from './components/SupportSection';
import './AccountManagement.css';

interface AccountManagementProps {
  className?: string;
}

export const AccountManagement: React.FC<AccountManagementProps> = ({ 
  className 
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (isMobile) {
    return (
      <div className={`account-management-mobile ${className || ''}`}>
        <main className="main-content-mobile">
          <AccountSummary />
          <SettingsCards />
          <ActivitySection />
          <SupportSection />
        </main>
      </div>
    );
  }

  return (
    <div className={`account-management-web ${className || ''}`}>
      <main className="main-content-web">
        <AccountSummary />
        <SettingsPanel />
        <ActivitySection />
        <SupportSection />
      </main>
    </div>
  );
};

export default AccountManagement;
